import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface ConversationCallRecordingResponse {
  recording_url: string;
}

interface GetConversationCallRecordingPayload {
  company_id: string;
  subscription_id: string;
  call_id: string;
}

export async function getConversationCallRecording(
  payload: GetConversationCallRecordingPayload,
  auth: Authentication,
): Promise<ConversationCallRecordingResponse> {
  try {
    if (!payload.company_id || !payload.subscription_id || !payload.call_id) {
      throw new GetConversationCallRecordingFailure('company_id, subscription_id et call_id sont requis');
    }

    const response = await HttpClient.post('/company/conversations/recording', payload, auth.token);

    return response.data as ConversationCallRecordingResponse;
  } catch (e) {
    console.error('getConversationCallRecording error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetConversationCallRecordingFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetConversationCallRecordingFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetConversationCallRecordingFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
